import { Component, inject, input, InputSignal } from '@angular/core';
import { Router } from '@angular/router';
import { Entity } from '@cureskin/api-client-rn';
import { EventLoggerService } from '@services/event-logger-service';
import { AppConfig } from '../../../app.config';

export type PaymentDropOffOrder = Entity['Order'] | null;

@Component({
  selector: 'payment-drop-off',
  templateUrl: './payment-drop-off.html',
  styleUrls: ['../../../user/user-view/user-home/user-home.scss'],
  standalone: false,
})
export class PaymentDropOffComponent {
  readonly order: InputSignal<PaymentDropOffOrder> = input<PaymentDropOffOrder>(null);

  readonly appConfig = inject(AppConfig);
  private readonly eventLogger = inject(EventLoggerService);
  private readonly router = inject(Router);

  get isHairRegimen(): boolean {
    return this.order()?.regimen?.class === this.appConfig.Shared.Regimen.Class.HAIR;
  }

  get amount(): number {
    return this.order()?.amount ?? 0;
  }

  handleClick(): void {
    const order = this.order();
    if (!order?.objectId) return;
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'paymentDropOff' }));
    this.router.navigate(['/user/order', order.objectId, 'payment'], { queryParams: { back: 'home' } });
  }
}
